export const MEDICAL_CONDITIONS_ACTIVE_STATUSES = ['active', 'recurrence', 'relapse'];
export const ENUMS_MEDICAL_CONDITIONS_STATUSES = {
//
};
